<template>
  <div class="innerModal" v-if="taskType === 'assignaddonexclusiveusers'">
    <label
      v-if="taskType === 'assignaddonexclusiveusers'"
      class="bottommargin titlestyle"
      >Select available users</label
    >
    <el-input
      id="assignusersearch"
      v-model="userSearchValue"
      placeholder="Search"
      type="search"
      debounce="1000"
      class="rightmargin inpstyle bottommargin"
      data-cy="users-search"
    >
      <template #suffix>
        <img
          src="@/assets/icons/search.svg"
          style="width: 25px"
          alt="searchimg"
          title="searchimg"
        />
      </template>
    </el-input>
    <div
      :class="
        !showError
          ? 'useroverflowdiv heightnoerror'
          : 'heightwitherror useroverflowdiv'
      "
    >
      <div data-cy="users-table">
        <el-table
          id="assignusertable"
          v-loading="loading"
          v-if="taskType === 'assignaddonexclusiveusers'"
          ref="assignusertable"
          :data="availableUsers"
          style="width: 100%"
          :header-cell-style="headerstyle"
          :row-style="rowdatastyle"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
          @sort-change="handleSorting"
          :default-sort="{ prop: 'userName', order: 'ascending' }"
          empty-text="No users available"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="User Name" prop="userName" sortable />
          <el-table-column label="Email" prop="email" />
        </el-table>
      </div>
    </div>
    <div
      v-if="paging.totalPages > 1 && taskType === 'assignaddonexclusiveusers'"
      :class="!showError ? 'usermodalpagingdiv' : 'usermodalpagingdivwitherror'"
    >
      <label class="pagelabel"
        ><strong
          >Page {{ paging.currentPage }} / {{ paging.totalPages }}</strong
        ></label
      >
      <el-button
        plain
        class="paginationbtn"
        @click="paging.currentPage = 1"
        id="firstpage"
        :disabled="paging.currentPage === 1"
      >
        <img
          src="@/assets/icons/pagefirstenabled.svg"
          style="width: 20px"
          v-if="paging.currentPage !== 1"
          alt="firstpageiconimg"
          title="firstpageiconimg"
        />
        <img
          src="@/assets/icons/pagefirstdisabled.svg"
          style="width: 20px"
          v-if="paging.currentPage === 1"
          alt="firstpageiconimg"
          title="firstpageiconimg"
        />
      </el-button>
      <el-pagination
        layout="prev, next"
        :total="paging.totalRowsCount"
        :page-size="paging.perPage"
        v-model:current-page="paging.currentPage"
      />
      <el-button
        plain
        class="paginationbtn"
        @click="paging.currentPage = paging.totalPages"
        id="lastpage"
        :disabled="paging.currentPage === paging.totalPages"
      >
        <img
          src="@/assets/icons/pagelastenabled.svg"
          style="width: 20px"
          v-if="paging.currentPage !== paging.totalPages"
          alt="lastpageiconimg"
          title="lastpageiconimg"
        />
        <img
          src="@/assets/icons/pagelastdisabled.svg"
          style="width: 20px"
          v-if="paging.currentPage === paging.totalPages"
          alt="lastpageiconimg"
          title="lastpageiconimg"
        />
      </el-button>
    </div>
    <div v-if="showError" class="maxitemsdiv">
      <img
        src="@/assets/icons/warnerror.svg"
        class="warnimagestyle"
        alt="warnimg"
        title="warnimg"
      />
      <label class="errordiv" style="padding: 1rem 0">
        {{ errormsg }}
        {{ maxSeatsReachedAddOns.map((a) => a.productName).join(", ") }}
      </label>
    </div>
    <div class="buttonsdiv btnbottomdiv">
      <el-button
        id="assignusernext"
        round
        class="btnstyle ml-4"
        variant="warning"
        @click="nextClickHandler"
        :disabled="!enableNextButton"
        data-cy="addons-button-next"
        v-if="taskType === 'assignaddonexclusiveusers'"
      >
        Next
      </el-button>
      <el-button
        round
        class="btnstyle ml-4"
        variant="warning"
        id="backbutton"
        v-if="taskType === 'assignaddonexclusiveusers'"
        @click="backClickHandler"
        data-cy="addons-button-back"
      >
        Back
      </el-button>
      <el-button
        id="assignusercancel"
        round
        variant="outline-dark"
        @click="cancelInvite"
        class="cancelbtn"
        data-cy="addons-button-cancel"
        >Cancel</el-button
      >
    </div>
  </div>
</template>

<style lang="scss">
.el-table__fixed-right-patch {
  background-color: #efefef;
}

.headerstyle {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.errordiv {
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #df444d;
}

.maxitemsdiv {
  display: flex;
  align-items: center;
}

.btn-link {
  color: #101010;
}
.btnbottomdiv {
  bottom: 3%;
  position: fixed;
  width: 33%;
}

.warnimagestyle {
  width: 50px;
  height: 50px;
  margin-right: 10px;
}

.heightwitherror {
  max-height: 60%;
}
.heightnoerror {
  max-height: 65%;
}

.userdatadiv {
  display: flex;
  flex-direction: column;
  position: fixed;
  max-height: 60%;
  overflow: auto;
}

.canbtn {
  font-size: 16px;
  line-height: 24px;
}
.el-select-dropdown__item.selected {
  font-size: 14px;
  color: #606266;
  line-height: 34px;
  font-weight: 300;
}
.withheading {
  padding: 10px 10px 2rem 3rem;
}
.withoutheading {
  padding: unset;
}

.el-select .el-input.is-focus .el-input__inner {
  border-color: #bfbfbf;
  -moz-appearance: none !important;
  -webkit-appearance: none;
  appearance: none;
}

.btndiv {
  display: flex;
  flex-flow: row-reverse;
  bottom: 3rem;
  position: fixed;
  width: 80%;
}

.headlbl {
  color: #101010;
  display: block !important;
}

.el-select > .el-input {
  display: block;
  width: 80%;
}

.cancelbtn {
  background: unset;
  border: 1px solid #101010;
  font-size: 0.8rem;
  line-height: 1rem;
  width: 140px !important;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
}
.cancelbtn:hover {
  background: unset;
  color: #101010;
}

.checkbox-like {
  margin: auto;
  width: 1.25rem;
  height: 1.25rem;
  border: 0.2rem solid #666666;
  border-radius: 0.2rem;
  position: relative;
  &:after {
    content: "";
    display: block;
    width: 0.6rem;
    height: 1rem;
    transform: rotate(45deg);
    border: {
      bottom: 3px solid #666666;
      right: 3px solid #666666;
    }
    position: absolute;
    left: calc(50% - 0.3rem);
    top: calc(50% - 0.7rem);
    opacity: 0;
    transition: 0.2s;
  }
  &.checked {
    background-color: #ff5800;
    &:after {
      opacity: 1;
    }
  }
}

.usermodalpagingdiv {
  margin-top: 1.5rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.usermodalpagingdivwitherror {
  margin-top: 1.5rem;
  display: flex;
  justify-content: flex-end;
}

.fieldLength {
  font-style: italic;
  font-size: x-small;
  color: gray;
}
</style>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { mapGetters } from "vuex";
import APIService from "@/utils/APIService";
import {
  NotifiedUser,
  ProductInfomation,
  UserInformation,
} from "@/utils/AppInterfaces";
import { FlowActionTypes } from "@/store/flowstore/FlowActionTypes";
import { ProductActionTypes } from "@/store/productstore/ProductActionTypes";
import { AuthActionTypes } from "@/store/authstore/AuthActionTypes";

export default defineComponent({
  name: "AssignAddonUsersModal",
  components: {},
  computed: {
    ...mapGetters([
      "getTaskType",
      "getProductData",
      "getCurrentUser",
      "getCompanyData",
    ]),
    /* userOptions(): any {
      if (_.isEmpty(this.getUnassignedSubscriptionUsers) && !this.loading)
        this.getUnassignedUsersList();

      if (!_.isEmpty(this.getUnassignedSubscriptionUsers))
        this.updatePaginationData();

      return !_.isEmpty(this.getUnassignedSubscriptionUsers)
        ? this.getUnassignedSubscriptionUsers.items
        : [];
    },*/
    taskType(): string {
      return this.getTaskType;
    },
    userSearchValue: {
      get(): string {
        return this.searchUser;
      },
      set(val: string) {
        this.searchUser = val;
      },
    },
    enableNextButton(): boolean {
      return this.selectedUsers.length > 0 && !this.showError;
    },
  },
  data() {
    return {
      inviteData: {
        firstName: "",
        lastName: "",
        email: "",
        companyBucketId: "",
        userBucketId: null,
        role: null,
        roleId: 5,
      },
      availableUsers: [] as UserInformation[],
      selectedUsers: [] as UserInformation[],
      companyBucketId: "",
      emaildata: {},
      headerstyle: {
        "border-bottom": "unset",
        "font-family": "Open Sans, sans-serif",
        "font-weight": "700",
        "font-size": "0.8rem",
        "line-height": "1rem",
        color: "#101010",
      },
      rowdatastyle: {
        "font-family": "Open Sans, sans-serif",
        "font-weight": "400",
        "font-size": "0.8rem",
        "line-height": "1rem",
        color: "#101010",
      },
      enableControls: true,
      notifiedUsers: [] as NotifiedUser[],
      task: "",
      showError: false,
      maxSeatsReachedAddOns: [] as ProductInfomation[],
      loading: true,
      addUserError: "",
      errormsg:
        "Maximum license / seat is reached, no more user can be assigned to the add-ons;",
      totalRows: 1,
      searchUser: "",
      userval: "",
      userSelectionList: [] as any[],
      pagechange: false,
      sortingField: 1,
      sortingOrder: 1,
      paging: {
        currentPage: 1,
        perPage: 10,
        pagesNumber: 1,
        totalPages: 0,
        totalRowsCount: 0,
        itemsOnPage: 0,
      },
    };
  },
  watch: {
    userSearchValue() {
      this.getUnassignedUsersList();
    },
    "paging.currentPage"(newVal: number, oldVal: number) {
      if (newVal !== oldVal) {
        this.pagechange = true;
        this.getUnassignedUsersList();
      }
    },
  },
  methods: {
    /*  updatePaginationData() {
      this.paging.totalRowsCount =
        this.getUnassignedSubscriptionUsers.totalItems;
      this.paging.perPage = this.getUnassignedSubscriptionUsers.pageSize;
      this.loading = false;
    },*/
    getUnassignedUsersList() {
      this.loading = true;
      const apiService = new APIService(this.axios);

      const queryModel = {
        companyBucketId: this.companyBucketId,
        userBucketId: this.getCurrentUser.result.userBucketId,
        searchPhrase: this.userSearchValue,
        mainProduct: {
          productBucketId: this.getProductData?.productBucketId,
          majorVersionNumber: this.getProductData?.majorVersionNumber,
          minorVersionNumber: this.getProductData?.minorVersionNumber,
          licenseTypeLimit: 0,
        },
        addons: this.selectedAddOns,
        pageOptions: {
          skip: this.paging.currentPage - 1,
          take: this.paging.perPage,
          sortField: this.sortingField,
          sortOrder: this.sortingOrder,
        },
      };
      apiService
        .SearchAddonUnassignedUsers(queryModel)
        .then((resp) => {
          this.availableUsers = resp.items;
          this.loading = false;
          this.paging.totalPages = resp.pagingData.totalPages;
          this.paging.totalRowsCount = resp.pagingData.itemCount;
        })
        .catch((error) => {
          this.loading = false;
          if (error.code === "ECONNABORTED")
            this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
        });
    },
    getCurrentCompany() {
      switch (this.$route.name) {
        case "account":
          this.companyBucketId = this.getCurrentUser.result.companyBucketId;
          break;
        case "companies":
          this.companyBucketId = this.getCompanyData.companyBucketId;
          break;
        default:
          this.companyBucketId = this.getCurrentUser.result.companyBucketId;
          break;
      }
    },
    handleSelectionChange(selected: any[]) {
      if (!this.HasAvailableSeatsExceeded(selected)) {
        this.selectedUsers = selected;
        /*this.$store.dispatch(
          FlowActionTypes.SET_SELECTED_EMAILS,
          this.mainUserSelection
        );*/
        this.$store.dispatch(
          FlowActionTypes.SET_SELECTED_USERS,
          this.selectedUsers
        );
      }
    },
    handleSorting({ prop, order }: { prop: any; order: any }) {
      this.sortingField = prop === "userName" ? 1 : 0;
      this.sortingOrder = order === "ascending" ? 0 : 1;
    },
    cancelInvite() {
      this.$store.dispatch(FlowActionTypes.SET_SHOW_ADDPRODUCTS, false);
      this.$store.dispatch(FlowActionTypes.SET_SHOW_ASSIGNADDON, false);
      this.$store.dispatch(
        FlowActionTypes.SET_SHOW_ASSIGNADDON_EXCLUSIVE,
        false
      );
      this.$store.dispatch(ProductActionTypes.SET_ADDONS_LIST, []);
      this.$store.dispatch(FlowActionTypes.SET_SELECTED_EMAILS, []);
      this.$store.dispatch(FlowActionTypes.SET_SELECTED_USERS, []);
      this.$store.dispatch(FlowActionTypes.SET_PRODUCT_DATA, {});
      this.$store.dispatch(FlowActionTypes.SET_TASK_TYPE, "none");
      this.$store.dispatch(ProductActionTypes.SET_AVAILABLE_PRODUCTS, {
        items: [],
      });
    },
    nextClickHandler() {
      this.$store.dispatch(
        FlowActionTypes.SET_TASK_TYPE,
        "assignaddonexclusivesummary"
      );
    },
    backClickHandler() {
      this.$store.dispatch(
        FlowActionTypes.SET_TASK_TYPE,
        "assignaddonexclusive"
      );
    },
    HasAvailableSeatsExceeded(selected: any[]) {
      if (selected.length > 0) {
        if (this.selectedAddOns && Array.isArray(this.selectedAddOns)) {
          this.selectedAddOns.forEach((addOn) => {
            let usersToAssign = 0;
            selected.forEach((user) => {
              if (
                !user.addOns.some(
                  (a: ProductInfomation) =>
                    a.productBucketId === addOn.productBucketId
                )
              ) {
                usersToAssign += 1;
                if (usersToAssign > addOn.seats - addOn.seatsUsed) {
                  this.maxSeatsReachedAddOns.push(addOn);
                } else {
                  if (Array.isArray(this.maxSeatsReachedAddOns)) {
                    this.maxSeatsReachedAddOns =
                      this.maxSeatsReachedAddOns.filter(
                        (a) => a.productBucketId !== addOn.productBucketId
                      );
                  }
                }
              }
            });
          });
          return (this.showError = this.maxSeatsReachedAddOns.length > 0);
        }
      }
    },
  },
  props: {
    selectedAddOns: {
      type: Array as PropType<ProductInfomation[]>,
      required: false,
    },
  },
  mounted() {
    this.getCurrentCompany();
    this.getUnassignedUsersList();
  },
});
</script>
